const product = [
  // {
  //     id: 1,
  //     image: null,
  //     name: null,
  //     size: null,
  //     sizeSmall:null,
  //     category: null,
  //     link: null
  //   },
    {
      id: 2,
      image: "images/Adobe_Photoshop_CC_icon.svg.png",
      name: "Photo Shop",
      size: 3,
      sizeSmall: 10,
      category: "softwares",
      link: "https://getintopc.com/softwares/graphic-design/adobe-photoshop-2022-free-download-7218191/"
    },
    {
      id: 3,
      image: "images/Adobe_Illustrator_CC_icon.svg.png",
      name: "Illustrator",
      size: 1,
      sizeSmall: 80,
      category: "softwares",
      link: "https://getintopc.com/softwares/designing-tool/adobe-illustrator-cc-2022-free-download-1099557/"
    },
  
    {
      id: 5,
      image: "images/pr.png",
      name: "Premire Pro",
      size: 8,
      sizeSmall: 10,
      category: "softwares",
      link: "https://getintopc.com/softwares/video-editing/adobe-premiere-pro-2022-free-setup-download-7678617/"
    },
    {
      id: 6,
      image: "images/lrMobile.png",
      name: "Lightroom",
      size: 0,
      sizeSmall: 860,
      category: "softwares",
      link: "https://getintopc.com/softwares/image-managers/adobe-photoshop-lightroom-classic-2022-free-download-4542454/"
    },
    {
      id: 7,
      image: "images/AfterEffects.png",
      name: "After Effects",
      size: 2,
      sizeSmall: 10,
      category: "softwares",
      link: "https://getintopc.com/softwares/graphic-design/adobe-after-effects-2021-free-download-1596101/"
    },
    {
      id: 8,
      image: "images/images.jpeg",
      name: "Office 365",
      size: 1,
      sizeSmall: 0,
      category: "softwares",
      link: "https://getintopc.com/softwares/office-tools/office-365-pro-plus-free-download-6652549/"
    },
    {
      id: 9,
      image: "images/msWord.jpeg",
      name: "MS word",
      size: 1,
      sizeSmall: 56,
      category: "softwares",
      link: "https://microsoft-word-2013.en.softonic.com/download"
    },
    {
      id: 10,
      image: "images/msExecl.jpeg",
      name: "MS Excel",
      size: 0,
      sizeSmall: 22,
      category: "softwares",
      link: "https://microsoft-excel.en.softonic.com/download"
    },
    {
      id: 11,
      image: "images/download.jpeg",
      name: "Edge",
      size: 0,
      sizeSmall: 130,
      category: "softwares",
      link: "https://www.microsoft.com/en-us/edge"
    },

  {
      id: 12,
      image: "images/recoverIt.png",
      name: "Recovery IT",
      size: 0,
      sizeSmall: 200,
      category: "softwares",
      link: "https://getintopc.com/softwares/data-recovery/wondershare-recoverit-2023-free-download/"
    },  {
      id: 13,
      image: "images/DoctorPhone.jpeg",
      name: "Dr.Fone",
      size: 0,
      sizeSmall: 200,
      category: "softwares",
      link: "https://getintopc.com/softwares/backup-recovery/wondershare-dr-fone-toolkit-for-ios-android-download-3113848/"
    },  {
      id: 14,
      image: "images/pdfElement.png",
      name: "PDF elelment",
      size: 0,
      sizeSmall: 128,
      category: "softwares",
      link: "https://getintopc.com/softwares/pdf-editors/wondershare-pdf-element-2022-free-download-1674761/"
    },  {
      id: 15,
      image: "images/filmora.png",
      name: "Filmora X ",
      size: 0,
      sizeSmall: 174,
      category: "softwares",
      link: "https://getintopc.com/softwares/video-editing/wondershare-filmora-x-2020-free-download-1470888/"
    }, 
    // {
    //   id: 16,
    //   image: "images/",
    //   name: "Acrobat DC",
    //   size: 0,
    //   sizeSmall: 0,
    //   category: "Games",
    //   link: ""
    //   },
      {
      id: 17,
      image: "images/gtaTriology.jpeg",
      name: "GTA Triology",
      size: 21,
      sizeSmall: 30,
      category: "Games",
      link: "https://fitgirl-repacks.site/grand-theft-auto-the-trilogy-the-definitive-edition/"
      },
      {
      id: 18,
      image: "images/Grand_Theft_Auto_V.png",
      name: "GTA V",
      size: 59,
      sizeSmall: 0,
      category: "Games",
      link: "https://oceansofgamess.com/gta-v-free-download/"
      },
      {
      id: 19,
      image: "images/Grand_Theft_Auto_IV_cover.jpg",
      name: "GTA IV",
      size: 14,
      sizeSmall: 0,
      category: "Games",
      link: "https://oceansofgamess.com/gta-iv-updates-free-download/"
      },
      {
      id: 20,
      image: "images/GTASABOX.jpg",
      name: "GTA San Andreas",
      size: 3,
      sizeSmall: 37,
      category: "Games",
      link: "https://oceansofgamess.com/gta-san-andreas-setup-free-download/"
      },
      {
      id: 21,
      image: "images/Vice-city-cover.jpg",
      name: "GTA Vice City",
      size: 1,
      sizeSmall: 44,
      category: "Games",
      link: "https://oceansofgamess.com/gta-vice-city-setup-free-download/"
      },
      {
      id: 22,
      image: "images/GTA3boxcover.jpg",
      name: "GTA III",
      size: 0,
      sizeSmall: 661,
      category: "Games",
      link: "https://dl.kookdownload.com/game/computer/GTA_3_Persian%28www.kookdownload.com%29.rar"
      },
      {
      id: 23,
      image: "images/fifa 11.jpeg",
      name: "FIFA 21",
      size: 48,
      sizeSmall: 0,
      category: "Games",
      link: "https://oceansofgamess.com/fifa-19-free-download/"
      },
      {
      id: 24,
      image: "images/nfsHeat.jpeg",
      name: "Need for Speed",
      size: 8,
      sizeSmall: 0,
      category: "Games",
      link: "https://oceansofgamess.com/need-speed-hot-pursuit-2-free-download/"
      },
      {
      id: 25,
      image: "images/bettelfield.jpeg",
      name: "Battlefield 5",
      size: 54 ,
      sizeSmall: 40,
      category: "Games",
      link: "https://oceansofgamess.com/battlefield-v-free-download/"
      },
      
      //id: 26,
     // image: "images/Red_Dead_Redemption.jpg",
      //name: "Red Dead Redemption",
     // size: "",
     // sizeSmall: 0,
    //  category: "Games",
     // link: ""
      
      {
      id: 27,
      image: "images/rdr2.jpeg",
      name: "Red Dead Redemption 2",
      size: 80,
      sizeSmall: 0,
      category: "Games",
      link: "https://dl.kookdownload.com/game/computer/Red%20Dead%20Redemption%202%28www.kookdownload.com%29.rar"
      },
      
     // id: 28
      
      {
        id: 29,
        image: "images/mxPlayerOnline.png",
        name: "Android MX Player Online",
        size: 0,
        sizeSmall:24,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.mxtech.videoplayer.online"
        },
        {
        id: 30,
        image: "images/instender.png",
        name: "Instander",
        size: 0,
        sizeSmall:54,
        category: "Android",
        link: "https://instander.org/"
        },
        {
        id: 31,
        image: "images/lightroom.png",
        name: "Lightroom Mobile",
        size: 0,
        sizeSmall:92,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.adobe.lrmobile"
        },
        {
        id: 32,
        image: "images/blackhole.jpeg",
        name: "Black Hole",
        size: 0,
        sizeSmall:44,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.rise.blackhole"
        },
        {
        id: 33,
        image: "images/Spotifler.jpeg",
        name: "Spotiflyer",
        size: 0,
        sizeSmall:8,
        category: "Android",
        link: "https://spotiflyer.app/apk/"
        },
        {
        id: 34,
        image: "images/gbWhattsapp.jpeg",
        name: "GB Whatsapp",
        size: 0,
        sizeSmall:51,
        category: "Android",
        link: "https://file.gbapps.net/GBWhatsApp_April2.apk"
        },
        {
        id: 35,
        image: "images/picsArt.jpeg",
        name: "Picsart",
        size: 0,
        sizeSmall:44,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.picsart.studio"
        },
        {
        id: 36,
        image: "images/kinemaster.jpeg",
        name: "KineMaster",
        size: 0,
        sizeSmall:70,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.nexstreaming.app.kinemasterfree"
        },
        {
        id: 37,
        image: "images/rimini.png",
        name: "Remini",
        size: 0,
        sizeSmall:51,
        category: "Android",
        link: "https://play.google.com/store/apps/details?id=com.bigwinepot.nwdn.international/"
        },
        {
        id: 38,
        image: "images/xender.png",
        name: "Xender",
        size: 0,
        sizeSmall:20,
        category: "Android",
        link: "https://xender.pro/android.apk"
        },
        {
        id: 39,
        image: "images/newpie.png",
        name: "New Pie",
        size: 0,
        sizeSmall:10,
        category: "Android",
        link: "https://newpipe.en.uptodown.com/android/download"
        }
        
       // id: 40
        
        
       // id: 41,
     
        
       // id: 42,
        

    
]
export default product;